// extracted by mini-css-extract-plugin
module.exports = {"consentCountryForm":"consentCountryForm-WlB9T","consentNextButton":"consentNextButton-1WXLD"};